// extracted by mini-css-extract-plugin
export var alertIcon = "_tb-0";